var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.entry.tickets),function(ticket,index){return _c('ChecklistEntryTicket',{key:index,staticClass:"mb-2",attrs:{"entry":_vm.entry,"ticket":ticket}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }